export const categories = [
  { key: "singleDay", icon: "🌅", duration: "1" },
  { key: "multiDay", icon: "🗓️", duration: "2+" },
  { key: "concerts", icon: "🎵", category: "concerts" },
  { key: "cruise", icon: "🚢", category: "cruise" },
  { key: "seaside", icon: "🏖️", category: "seaside" },
  { key: "cigliaTours", icon: "⭐", category: "special" },
];

/**
 * Safely converts a value to a number.
 * Handles strings from database that should be numbers.
 * @param value - The value to convert (string, number, null, undefined)
 * @param defaultValue - Default value if conversion fails (default: 0)
 * @returns The numeric value
 */
export const toNumber = (
  value: string | number | null | undefined,
  defaultValue: number = 0,
): number => {
  if (value === null || value === undefined) return defaultValue;
  const num = typeof value === "string" ? parseFloat(value) : value;
  return isNaN(num) ? defaultValue : num;
};

/**
 * Formats a price value, removing unnecessary decimal places (.00)
 * @param price - The price value (number or string)
 * @returns Formatted price string without trailing .00
 */
export const formatPrice = (
  price: number | string | null | undefined,
): string => {
  if (price === null || price === undefined) return "";
  return String(price).replace(/\.00$/, "");
};

export const formatExtendedDate = (
  dateString: string,
  language: string,
): string => {
  const date = new Date(dateString);
  const locale = language === "it" ? "it-IT" : "en-US";

  const weekdayOptions: Intl.DateTimeFormatOptions = { weekday: "long" };
  const monthOptions: Intl.DateTimeFormatOptions = { month: "long" };
  const dayOptions: Intl.DateTimeFormatOptions = { day: "numeric" };
  const yearOptions: Intl.DateTimeFormatOptions = { year: "numeric" };

  const weekday = date.toLocaleDateString(locale, weekdayOptions);
  const month = date.toLocaleDateString(locale, monthOptions);
  const day = date.toLocaleDateString(locale, dayOptions);
  const year = date.toLocaleDateString(locale, yearOptions);

  // Capitalize first letter of weekday and month
  const capitalizedWeekday = weekday.charAt(0).toUpperCase() + weekday.slice(1);
  const capitalizedMonth = month.charAt(0).toUpperCase() + month.slice(1);

  // Reconstruct the date string based on locale
  if (locale === "it-IT") {
    return `${capitalizedWeekday} ${day} ${capitalizedMonth} ${year}`;
  } else {
    return `${capitalizedWeekday}, ${capitalizedMonth} ${day}, ${year}`;
  }
};
